// extracted by mini-css-extract-plugin
module.exports = {"container":"pa","overlay":"qa","headingSection":"ra","close":"sa","copy":"ta","m-heart-activate":"ua","bottomSection":"va","signInButton":"wa","disabled":"xa","m-heart-pulse":"ya"};